import { render, staticRenderFns } from "./ProductionUnits.vue?vue&type=template&id=1e8b246f"
import script from "./ProductionUnits.vue?vue&type=script&lang=js"
export * from "./ProductionUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports